import { LitElement, html, css } from 'lit';

export class ProgressBar extends LitElement {
	static styles = [
		css`
			:host {
				display: block;
			}

			.progress {
				position: relative;
			}

			.progress-bar-wrap {
				height: 2px;
				width: 100%;
				background-color: #f5f4f4;
				border-radius: 10px;
				position: relative;
				overflow: hidden;
			}

			.progress-bar {
				position: absolute;
				left: 0;
				top: 0;
				height: 100%;
				max-width: 100%;
				width: 0;
				border-radius: 10px;
				background-color: #000;
				transition: width 0.65s linear;
			}

			.marker-wrap {
				position: relative;
				width: 100%;
				height: 100%;
				display: flex;
				z-index: 0;
				align-items: center;
				justify-content: space-evenly;
			}

			.marker {
				width: 1px;
				height: 2px;
				background: #fff;
				opacity: 0.7;
			}

			.circle-wrap {
				position: absolute;
				width: 0;
				z-index: 1;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: flex-end;
				transition: width 0.65s linear;
			}
			.circle {
				position: absolute;
				background: #fff;
				width: 18px;
				height: 18px;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		`,
	];

	static properties = {
		max: { type: Number },
		value: { type: Number, reflect: true },
		marker: { type: Boolean },
		circle: { type: Boolean },
	};

	connectedCallback() {
		super.connectedCallback();
		this.max = this.max ?? 100;
		this.value = this.value ?? 0;
		this.circle = this.circle ?? false;
		this.marker = this.marker ?? false;
		this.value = this.value > this.max ? this.max : this.value;
	}

	_renderMarker() {
		if (this.marker) {
			return html`
				<div class="marker-wrap">
					<div class="marker"></div>
					<div class="marker"></div>
					<div class="marker"></div>
					<div class="marker"></div>
				</div>
			`;
		}
	}

	_renderCircle() {
		if (this.circle) {
			this.value = this.value > this.max ? this.max : this.value;
			return html`
				<div class="circle-wrap" style="width: ${this.value}%;">
					<div class="circle">
						<svg
							width="8"
							height="6"
							viewBox="0 0 8 6"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M1 3L3 5L7 1"
								stroke="#231F20"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
					</div>
				</div>
			`;
		}
	}

	render() {
		this.value = this.value > this.max ? this.max : this.value;
		return html`
			<div
				class="progress"
				role="progressbar"
				aria-valuenow="${this.value}"
				aria-valuemax="${this.max}"
				aria-valuemin="0"
			>
				${this._renderCircle()}
				<div class="progress-bar-wrap">
					<div
						class="progress-bar"
						aria-label="free shipping progress bar value ${this.value}%"
						style="width: ${this.value}%;"
					></div>
					${this._renderMarker()}
				</div>
			</div>
		`;
	}
}
if (!customElements.get('progress-bar')) {
	customElements.define('progress-bar', ProgressBar);
}
